// extracted by mini-css-extract-plugin
module.exports = {"theResidencesBanner":"style_theResidencesBanner__IXbhe","theResidencesContent":"style_theResidencesContent__iRY4C"};